import styled from "styled-components";

/* Layout geral */
export const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  
`;

/* Sidebar */
export const Sidebar = styled.div`
  width: 240px;
  background-color: #1e293b;
  color: white;
  padding: 20px;
`;

export const SidebarTitle = styled.h2`
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: bold;
`;

export const MenuButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  text-align: left;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #334155;
  }
`;

/* Conteúdo principal */
export const MainContent = styled.div`
  flex-grow: 1;
  padding: 30px;
  background-color: #f8fafc;
  text-align: center;
  margin-top: 80px;
  margin-bottom: 80px; 
`;

/* Cards */
export const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 30px;
`;

export const Card = styled.div`
  background: #ffffff;
  border: 2px solid ${({ borderColor }) => borderColor || "#ccc"};
  border-radius: 12px;
  padding: 20px;
  width: 220px;
  box-shadow: 0px 2px 8px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.p`
  margin-top: 8px;
  font-size: 14px;
  color: #555;
`;

export const Value = styled.h2`
  font-size: 24px;
  color: ${({ cor }) => cor || "#000"};
`;

/* Gráfico */
export const ChartRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
`;

export const ChartContainer = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 2px 10px rgba(0,0,0,0.08);
  flex: 1;
  min-width: 400px;
  max-width: 600px;
  h2 {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    text-align: center;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 20px 0;
  justify-content: center;
  align-items: center;
`;

export const FilterSelect = styled.select`
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
`;

export const DateRangeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const DateInput = styled.input`
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
`;

export const ApplyButton = styled.button`
  padding: 8px 16px;
  background-color: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background-color: #1d4ed8;
  }
`;

// KPI
export const KpiContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-bottom: 40px;
`;

export const KpiCard = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 2px 10px rgba(0,0,0,0.1);
  width: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const KpiTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

export const KpiValue = styled.p`
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 4px;
`;

export const KpiTrend = styled.div`
  display: flex;
  align-items: center;
  color: ${({ color }) => color || '#333'};
  gap: 6px;
  font-weight: 500;
`;

export const KpiDescription = styled.small`
  color: #666;
  font-size: 12px;
`;

// Tooltip
export const InfoIcon = styled.span`
  cursor: pointer;
  margin-left: 8px;
  color: #888;
`;

export const TooltipContent = styled.div`
  position: absolute;
  background-color: #1e293b;
  color: white;
  padding: 10px;
  border-radius: 6px;
  font-size: 12px;
  max-width: 250px;
  z-index: 10;
  top: 25px;
  left: 0;
`;